import React from "react";
import ReactTooltip from "react-tooltip";
import { IconButton, Icon } from "../../_components";

export function MapListItem(props) {
  const { mapItem, controls, onDelete, onEdit, click, active, onSelect } =
    props;
  const { image, title, description, options } = mapItem;
  const { coordX, coordY, zoomDefault } = options;

  function handleDelete(ev) {
    ev.stopPropagation();
    onDelete(mapItem._id);
  }

  function handleEdit(ev) {
    ev.stopPropagation();
    onEdit(mapItem._id);
  }

  function handleClick(ev) {
    if (click) {
      ev.stopPropagation();
      click();
    }
  }

  function handleSelect(ev) {
    if (onSelect) {
      onSelect(mapItem);
    }
  }
  return (
    <li
      className={
        "chronos-maplist-item chronos-list-item" +
        (active ? " chronos-map-item-active" : "")
      }
      onClick={handleClick}
    >
      <div className="chronos-list-item-image">
        {image && image.url && <img src={image.url} alt={title} />}
        {image && image.data && <img src={image.data} alt={title} />}
      </div>
      <div className="chronos-list-item-text">
        <h5 className="chronos-list-item-title">{title}</h5>
        <p className="chronos-list-item-desc">{description}</p>
        <span className="text-muted">
          <span
            className="chronos-map-coords"
            data-tip="Default Coordinates (Lat,Lng)"
          >
            <Icon icon="fal fa-map-marker" />
            {coordX},{coordY}
          </span>
          <span className="chronos-map-zoom" data-tip="Default Zoom">
            <Icon icon="fal fa-search-plus" />
            {zoomDefault}
          </span>
        </span>
      </div>
      {controls && (
        <div className="chronos-list-item-controls">
          {onSelect && (
            <IconButton
              data-tip="Select"
              icon="fas fa-crosshairs fa-fw"
              color="success"
              disabled={active}
              onClick={handleSelect}
              style={{ zIndex: 1 }}
            />
          )}
          {onEdit && (
            <IconButton
              data-tip="Edit"
              icon="fas fa-pencil fa-fw"
              color="primary"
              onClick={handleEdit}
            />
          )}
          {onDelete && (
            <IconButton
              data-tip="Delete"
              icon="fas fa-trash fa-fw"
              color="danger"
              onClick={handleDelete}
            />
          )}
        </div>
      )}
      <ReactTooltip className="chronos-form-button-tooltip" effect="solid" />
    </li>
  );
}
